<template>
    <div>
        <RemoteTable ref="table" :form="form" :table="table">
            <template #default="{row, property}">
                <template v-if="property === 'code'">
                    {{getName(row.code)}}
                </template>
            </template>
        </RemoteTable>
        <el-dialog title="请选择新增方式"
                :visible.sync="dialog.visible"
                width="40%" center>
            <div style="text-align: center">
                <el-button @click="closeDialog('batch')">文件导入</el-button>
                <el-button type="primary" @click="closeDialog('')">手工录入</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'

    export default {
        components: {
            RemoteTable
        },
        data() {
            return {
                form: {
                    configs: this.getConfigs(),
                    tools: [
                        {
                            label: "导出",
                            click: () => {
                              this.$confirm("确认进行导出操作？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: 'warning'
                              }).then(() => {
                                this.$axios.post('/blacklist/download', this.$refs.table.getQueryInfo()).then(response => {
                                    if (response.success) {
                                        this.$message(response['message']);
                                    } else {
                                        this.$message.error(response['message']);
                                    }
                                });
                              });
                            }
                        },
                        {
                            icon: "el-icon-plus", click: () => {
                                this.dialog.visible = true;
                            }
                        }
                    ]
                },
                table: {
                    urlPrefix: "/blacklist",
                    columns: [
                        {label: "业务名称", name: "code"},
                        {label: "手机号", name: "mobile", width: 120},
                        {label: "级别", name: "level", width: 80},
                        {label: "备注", name: "remark", width: 100},
                        {label: "创建时间", name: "createTime", width: 150},
                    ],
                    primaryColumns: [
                        {name: "mobile"}
                    ],
                    tools: []
                },
                dialog: {
                    visible: false,
                    type: ''
                }
            }
        },
        methods: {
            getConfigs() {
                let configs = [];
                configs.push({label: "业务", name: "code", type: "cascade", op: "beginwith", value: ""});
                configs.push({label: "手机号", name: "mobile", type: "input", op: "contains", value: ""});
                configs.push({label: "级别", name: "level", type: "select", value: "", url: "/dict/list/public/level"});
                configs.push({label: "创建时间", name: "createTime", type: "datetimerange", op: "between"});
                return configs;
            },
            getName(code) {
                if (!code || "00000" === code) {
                    return "";
                }

                if (code.length > 6) {
                    return this.$root.getBusinessName(code);
                } else {
                    return this.$root.getCustomerName(code);
                }
            },
            closeDialog(type) {
                this.dialog.visible = false;

                if (type === 'batch') {
                    this.$router.push("/blacklist/import");
                } else {
                    this.$router.push("/blacklist/0");
                }
            }
        }
    }
</script>